import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_state_quote = {
  get_covers: false,
  quotationNo: '',
  quotationStatus: '',
  quoteCreationDate: '',
  productType: '',
  productVariant: '',
  proposalNumber: '',
  productTypeValue: '',
  businessType: '',
  businessTypeValue: '',
  currentTab: 'vehicle',
  isQuoteSaving: false,
  isCopyFromOutside: false,
  isQuoteCopied: false,
  captureMode: 'create',
  regNo: '',
  isRegNoVerified: null,
  isZoopServiceCalled: null,
  isPrevClaimsAvailable: null,
  isPrevInsuranceAvailable: null,
  isPrevInsuranceLoading: false,
  mode: '',
  coverDisable: false,
  ConcoverDisable: false,
  coverRTIDisable: false,
  coverEngineeDisable: false,
  disableNCB: false,
  vehicleRegNo: {
    part1: '',
    part2: '',
    part3: '',
    part4: '',
    bhseries: ''
  },
  dep_selected: false,
  TP_Policy_Tenure: '',
  TP_Start_Date: '',
  TP_End_Date: '',
  suggestedIDV: '',
  minSuggestedIDV: '',
  maxSuggestedIDV: '',
  irfPctMin: '',
  idvPctMin: '',
  irfPctMax: '',
  idvPctMax: '',
  changedIDV: '',
  chasisIDV: '',
  bodyIDV: '',
  totalIDV: '',
  changedGVW: '',
  suggestedGVW: '',
  adjustmentIRF: '0',
  adjustmentIRF2: '',
  IRF2comments: '',
  gvwmin: '',
  gvwmax: '',
  irfPct: '',
  idvPct: '',
  anyPreviousPolicyforVehicleTaken: 'No',
  showCalculatePremiumButtonIDV: false,
  isVehicleDetailsAvailable: false,
  isTrailerRequired: false,
  coverforlamps: false,
  coverforprivateandcommercial: false,
  vehicleusedlimitedtoownpremises: false,
  vehicleuseddrivingtuitions: false,
  ImportedVehicle: false,
  ConfinedtoOwnPremises: false,
  SoftCopyDiscount: false,
  AntiTheftDiscount: false,
  nooftrailers: '',
  towedby: '',
  QuotationRecordNo: '',
  policyCoverType: '',
  policyTenure: '',
  policyTenureValue: '',
  policyTerm: '',
  policyStartDate: '',
  policyExpiryDate: '',
  totalClaimCount: '',
  totalClaimCountValue: '',
  noOfClaimsOneYear: '',
  noOfClaimsTwoYears: '',
  noOfClaimsThreeYears: '',
  totalClaimAmount: '',
  previousYearNCBSlab: '',
  vehicleIsOwnedBy: '',
  vehicleOwnerTypeAndGender: {
    gender: '',
    organisationType: ''
  },
  pincode: '',
  state: '',
  district: '',
  city: '',
  getAdditionalCreditScore: 'No',
  idProofType: '',
  idProofNumber: '',
  cs_proposer_first_name: '',
  cs_proposer_middle_name: '',
  cs_proposer_last_name: '',
  cs_proposer_mobileNo: '',
  cs_proposerDOB: '',
  voluntaryDeductibleAmount: '',
  make: {
    code: '',
    value: ''
  },
  model: {
    code: '',
    value: ''
  },
  variant: {
    code: '',
    value: ''
  },
  vehiclesubType: {
    code: '',
    value: ''
  },
  carriageType: {
    code: '',
    value: ''
  },
  usageType: {
    code: '',
    value: ''
  },
  typeofCarriage: {
    code: '',
    value: ''
  },
  typeOfMiscVehicle: {
    code: '',
    value: ''
  },
  typeOfBody: '',
  permitType: {
    code: '',
    value: ''
  },
  vehicleuse: {
    code: '',
    value: ''
  },
  natureofgoods: {
    code: '',
    value: ''
  },
  subProduct: {
    code: '',
    value: ''
  },
  fuelType: '',
  seatingCapacity: '',
  cubeCapacity: '',
  carryingCapacity: '',
  gvw: '',
  segmentType: '',
  trailerDetails: [],
  yearOfManufacture: '',
  dateOfReg: '',
  rtoLocationCode: '',
  rtoLocationDesc: '',
  rtoAuthorityCode: '',
  engineNo: '',
  chasisNo: '',
  preInspectionNumber: '',
  financerName: '',
  prevInsurance: {
    insurerName: '',
    policyNumber: '',
    expiryDate: '',
    startDate: '',
    coverType: '',
    policyTenure: ''
  },
  tenure: '',
  coverData: {
    addOnCovers: [],
    rawRiskData: []
  },
  premiumData: {
    idv1: '',
    idv2: '',
    idv3: '',
    tenure: '',
    netODPremium: null,
    netTPPremium: null,
    loadingDiscount: null,
    netPremium: null,
    gst: null,
    stampDuty: null,
    totalPremium: null,
    loading: [],
    discount: [],
    vehicleAge: '',
    claimFreeYear: '',
    creditScore: ''
  },
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  customer: {},
  customerMeta: {},
  isPremiumCalculating: null,
  isQuoteSavingWOCust: false,
  QuoteSavingWOCustIndex: null,
  zoopCustDtls: {}
};
var motorQuoteVar = makeVar(init_state_quote); // export const initMotorQuoteState = () =>
//   motorQuoteVar(init_state_quote);

var initMotorQuoteState = function initMotorQuoteState(isCopyFromOutside) {
  var _motorQuoteVar;

  if (isCopyFromOutside && (_motorQuoteVar = motorQuoteVar()) !== null && _motorQuoteVar !== void 0 && _motorQuoteVar.isCopyFromOutside) {
    motorQuoteVar(_objectSpread2(_objectSpread2({}, motorQuoteVar()), {}, {
      isCopyFromOutside: false
    }));
    return true;
  }

  motorQuoteVar(init_state_quote);
  return false;
};
var updateMotorQuote = function updateMotorQuote(data) {
  motorQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, motorQuoteVar()), data), {}, {
    get_covers: true
  }));
};
var updateCustomerInformation = function updateCustomerInformation(customerInformation) {
  return motorQuoteVar(_objectSpread2(_objectSpread2({}, motorQuoteVar()), {}, {
    customer: customerInformation !== null && customerInformation !== void 0 && customerInformation.customer ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customer : {},
    customerMeta: customerInformation !== null && customerInformation !== void 0 && customerInformation.customerMeta ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customerMeta : {}
  }));
};
var updateQuotationDetails = function updateQuotationDetails(quotationNo, quotationStatus, quoteCreationDate, addOnCovers, isQuoteSavingWOCust, QuoteSavingWOCustIndex) {
  if (isQuoteSavingWOCust && QuoteSavingWOCustIndex) {
    motorQuoteVar(_objectSpread2(_objectSpread2({}, motorQuoteVar()), {}, {
      quotationNo: quotationNo,
      quotationStatus: quotationStatus,
      quoteCreationDate: quoteCreationDate,
      coverData: {
        addOnCovers: addOnCovers,
        rawRiskData: []
      },
      isQuoteSavingWOCust: isQuoteSavingWOCust,
      QuoteSavingWOCustIndex: QuoteSavingWOCustIndex
    }));
  } else {
    motorQuoteVar(_objectSpread2(_objectSpread2({}, motorQuoteVar()), {}, {
      quotationNo: quotationNo,
      quotationStatus: quotationStatus,
      quoteCreationDate: quoteCreationDate,
      coverData: {
        addOnCovers: addOnCovers,
        rawRiskData: []
      }
    }));
  }
};

export { initMotorQuoteState, init_state_quote, motorQuoteVar, updateCustomerInformation, updateMotorQuote, updateQuotationDetails };
